import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { NavLink } from 'redux-first-router-link';
import cc from 'classcat';
import noScroll from 'no-scroll';

import { selectTheme } from '../../store/theme/selectors';

import styles from './styles.module.scss';

// must match animation duration found in styles
const ANIMATION_DURATION = 350;

class Menu extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    primaryItems: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        }),
      })
    ),
    secondaryItems: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        }),
      })
    ),
    className: PropTypes.string,
  };
  static defaultProps = {
    onClose: () => {},
  };

  state = {
    closing: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.open && !this.props.open) {
      this.hideMenu();
    } else if (!prevProps.open && this.props.open) {
      this.showMenu();
    }
  }

  componentDidMount() {
    if (this.props.open) {
      this.showMenu();
    }
  }

  componentWillUnmount() {
    noScroll.off();
  }

  showMenu = () => {
    noScroll.on();
    this.setState({ closing: false });
  };

  hideMenu = () => {
    noScroll.off();
    this.setState(
      {
        closing: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            closing: false,
          });
        }, ANIMATION_DURATION);
      }
    );
  };

  handleClose = () => this.props.onClose();

  render() {
    const { open, className, primaryItems, secondaryItems, theme } = this.props;
    const { closing } = this.state;

    return (
      <div
        className={cc([
          {
            [styles.open]: open,
            [styles.closing]: closing,
          },
          styles.container,
          styles[theme],
          className,
        ])}
        onClick={this.handleClose}
      >
        <div className={styles.nav} onClick={this.handleClose}>
          <nav className={styles.primaryNav} role="navigation">
            {primaryItems?.map(({ fields: { label, link } }) => (
              <NavLink
                key={link}
                to={link}
                onClick={this.handleClose}
                className={styles.item}
                activeClassName={styles.active}
              >
                <div>{label}</div>
              </NavLink>
            ))}
          </nav>

          <nav className={styles.secondaryNav}>
            {secondaryItems?.map(({ fields: { label, link } }) => (
              <NavLink
                key={link}
                to={link}
                onClick={this.handleClose}
                className={styles.item}
                activeClassName={styles.active}
              >
                <div>{label}</div>
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    );
  }
}

export default compose(
  connect((state) => ({
    theme: selectTheme(state),
  }))
)(Menu);
